export const headersForSwitchDeposit = [
    {
        "title": "Deposit from my Wallet",
        "short_title": "deposit_from_my_wallet"
    },
    {
        "title": "Deposit from another Depository",
        "short_title": "deposit_from_another_depository"
    },
    {
        "title": "Withdraw to my Wallet",
        "short_title": "withdraw_to_my_wallet"
    },
    {
        "title": "Send to another Depository",
        "short_title": "send_to_another_depository"
    },
    // {
    //     "title": "Buy CPT",
    //     "short_title": "buy_CPT"
    // }
]
